const normalizeId = (value) =>
  value === null || value === undefined || value === ""
    ? null
    : String(value);

const getCompanyDetailsList = (masterData) => {
  if (!masterData || Array.isArray(masterData)) {
    return [];
  }

  if (Array.isArray(masterData.CompanyDetails)) {
    return masterData.CompanyDetails;
  }

  if (masterData.CompanyDetails && typeof masterData.CompanyDetails === "object") {
    return [masterData.CompanyDetails];
  }

  return [];
};

const getClientCompaniesList = (clientCompanyData) => {
  if (Array.isArray(clientCompanyData)) {
    return clientCompanyData;
  }

  if (clientCompanyData && typeof clientCompanyData === "object") {
    return [clientCompanyData];
  }

  return [];
};

const findCompanyByIds = (companies, ids) => {
  const normalizedIds = ids.map(normalizeId).filter(Boolean);

  if (!normalizedIds.length) {
    return null;
  }

  return (
    companies.find((company) => {
      const companyIds = [
        company?.CompanyId,
        company?.ClientId,
      ]
        .map(normalizeId)
        .filter(Boolean);

      return companyIds.some((companyId) => normalizedIds.includes(companyId));
    }) || null
  );
};

const resolveCompanyName = ({
  user,
  masterData,
  clientCompanyData,
  tokenCompanyId,
}) => {
  const directName = user?.CompanyName?.trim();
  if (directName && directName.toLowerCase() !== "not available") {
    return directName;
  }

  const lookupIds = [
    user?.CompanyId,
    user?.ClientId,
    tokenCompanyId,
  ];

  const masterCompanies = getCompanyDetailsList(masterData);
  const matchedFromMaster = findCompanyByIds(masterCompanies, lookupIds);
  if (matchedFromMaster?.CompanyName) {
    return matchedFromMaster.CompanyName;
  }

  const clientCompanies = getClientCompaniesList(clientCompanyData);
  const matchedFromClient = findCompanyByIds(clientCompanies, lookupIds);
  if (matchedFromClient?.CompanyName) {
    return matchedFromClient.CompanyName;
  }

  const activeMasterCompany =
    masterCompanies.find((company) => company?.DataStatus === 1) ||
    masterCompanies[0];
  if (activeMasterCompany?.CompanyName) {
    return activeMasterCompany.CompanyName;
  }

  const activeClientCompany =
    clientCompanies.find((company) => company?.DataStatus === 1) ||
    clientCompanies[0];
  if (activeClientCompany?.CompanyName) {
    return activeClientCompany.CompanyName;
  }

  return "Not Available";
};

export default resolveCompanyName;
